module.exports = __webpack_public_path__ + "static/media/alert.d3b9525b.png";